import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCustomer, getEndUser } from '../../../../data/booking/selectors/booking';
import EndUser from '../../../booking/components/end_user/EndUser';
import * as customerTypes from '../../../../data/booking/constants/customer_types';
import { editEndUser } from '../../../../data/booking/actions/booking';

class EndUserContainer extends Component {
    static propTypes = {
        customer: PropTypes.object,
        endUser: PropTypes.object,
        editEndUser: PropTypes.func
    };

    handleClickEdit() {
        this.props.editEndUser();
    }

    render() {
        const { customer, endUser } = this.props;

        if (!customer || customerTypes.CONSUMER === customer.type) {
            return null;
        }
        return (
            <EndUser
                endUser={endUser}
                onClickEdit={::this.handleClickEdit}
            />
        );
    }
}

export default connect(
    state => ({
        customer: getCustomer(state.booking),
        endUser: getEndUser(state.booking)
    }),
    dispatch => bindActionCreators({ editEndUser }, dispatch)
)(EndUserContainer);
